export function getEbitdaProfitBeforeTax(tooltips = {}) {
  return {
    //Group's Profit Before Tax
    group_profit_before_tax_s416_1: {
      label: "Group's Profit Before Tax from P&L - s416(1)",
      type: null,
      notes: tooltips.group_profit_before_tax_s416_1,
    },
    exclude_rd_credits_s104a_s416_2a: {
      label: "Exclude R&D expenditure credits within s104A CTA 2009 - s416(2A)",
      type: "negative",
      notes: tooltips.exclude_rd_credits_s104a_s416_2a,
    },
    eliminate_derivative_fv_amounts_s420_3: {
      label:
        "Adjustment to eliminate all amounts in respect of derivatives subject to fair value accounting to which Regulation 7, 8 or 9 of the Disregard Regulations would apply - s420(3)",
      type: null,
      notes: tooltips.eliminate_derivative_fv_amounts_s420_3,
    },
    include_replacement_derivative_amounts_s420_5: {
      label:
        "Adjustment to include all replacement derivative contract amounts for derivatives subject to fair value accounting to which Regulation 7, 8 or 9 of the Disregard Regulations would apply - s420(5)",
      type: null,
      notes: tooltips.include_replacement_derivative_amounts_s420_5,
    },
  };
}

export function getEbitdaDepreciationAndAmortisationAdjustment(tooltips = {}) {
  // Depreciation and Amortisation adjustment - Capital Expenditure Adjustment (s417):
  return {
    relevant_assets_depreciation_s417_2a: {
      label: "Depreciation of relevant assets - s417(2)(a)",
      type: "positive",
      notes: tooltips.relevant_assets_depreciation_s417_2a,
    },
    relevant_assets_amortization_s417_2a: {
      label: "Amortisation of relevant assets - s417(2)(a)",
      type: "positive",
      notes: tooltips.relevant_assets_amortization_s417_2a,
    },
    relevant_assets_impairment_s417_2a: {
      label: "Impairment of relevant assets - s417(2)(a)",
      type: null,
      notes: tooltips.relevant_assets_impairment_s417_2a,
    },
    capital_expenditure_relevant_assets_s417_2b: {
      label:
        "Expenditure of a capital nature that relates to relevant assets that is incurred and recognised in the relevant period of account - s417(2)(b)",
      type: "positive",
      notes: tooltips.capital_expenditure_relevant_assets_s417_2b,
    },
    provision_future_capital_expenditure_s417_2c: {
      label:
        "Amounts recognised in the relevant period of account by way of provision in respect of future expenditure of a capital nature that relates to relevant assets - s417(2)(c)",
      type: "positive",
      notes: tooltips.provision_future_capital_expenditure_s417_2c,
    },
    reversal_capital_expenditure_s417_1_3: {
      label:
        "Reversal of any capital expenditure recognised in an earlier period of account - s417(1)/(3)",
      type: "negative",
      notes: tooltips.reversal_capital_expenditure_s417_1_3,
    },
    capital_income_in_pbt_s417_1_4: {
      label:
        "Income of a capital nature brought into account in determining profit before tax - s417(1)/(4)",
      type: "negative",
      notes: tooltips.capital_income_in_pbt_s417_1_4,
    },
    capital_expenditure_adjustment_other: {
      label: "Capital expenditure adjustment (Other)",
      type: null,
      notes: tooltips.capital_expenditure_adjustment_other,
    },
  };
}

export function getEbitdaCapitalFairValueMovementAdjustment(tooltips = {}) {
  return {
    fair_value_movements_s418: {
      label:
        "Relevant fair value movements (fair value losses are positive / fair value gains are negative) - s418",
      type: null,
      notes: tooltips.fair_value_movements_s418,
    },
  };
}

export function getEbitdaCapitalDisposalsAdjustment(tooltips = {}) {
  //Capital disposals adjustment (s419):
  return {
    losses_disposals_relevant_assets_s419: {
      label:
        "Amounts in group's profit before tax that represent losses on disposals of relevant assets (positive) - s419",
      type: "positive",
      notes: tooltips.losses_disposals_relevant_assets_s419,
    },
    profits_disposals_relevant_assets_s419: {
      label:
        "Amounts in group's profit before tax that represent profits on disposals of relevant assets (negative) - s419",
      type: "negative",
      notes: tooltips.profits_disposals_relevant_assets_s419,
    },
    recalculated_profit_group_ebitda_s419_2_8: {
      label:
        "Recalculated profit amount - as adjusted by the Group-EBITDA (chargeable gains) election in s422 if made (positive) - s419(2)-(8)",
      type: "positive",
      notes: tooltips.recalculated_profit_group_ebitda_s419_2_8,
    },
  };
}

export function getEbitdaAdjustentsInRespectOfTheInterestAllowanceAlternativeCalculation(
  tooltips = {},
) {
  return {
    //Adjustments in respect of the interest allowance (alternative calculation) election (s423-426):
    remove_employer_pension_contributions_s424_2: {
      label:
        "Adjustment to remove amounts in respect of employers' pension contributions from PBT - s424(2)",
      type: "negative",
      notes: tooltips.remove_employer_pension_contributions_s424_2,
    },
    include_uk_tax_employer_pensions_s424_3: {
      label:
        "Adjustment to include UK tax deductions for employers' pension contributions - s424(3)",
      type: "positive",
      notes: tooltips.include_uk_tax_employer_pensions_s424_3,
    },
    remove_unpaid_remuneration_expenses_s424a_2: {
      label:
        "For periods of account beginning on or after 1 January 2019, adjustment to remove expenses in relation to employees' remuneration not paid within 9 months from PBT - s424A(2)",
      type: "positive",
      notes: tooltips.remove_unpaid_remuneration_expenses_s424a_2,
    },
    deduct_unpaid_remuneration_when_paid_s424a_3: {
      label:
        "Adjustment to deduct unpaid employees' remuneration which has previously been added back when it is paid - s424A(3)",
      type: "negative",
      notes: tooltips.deduct_unpaid_remuneration_when_paid_s424a_3,
    },
    remove_employee_share_acquisitions_s425_2: {
      label:
        "Adjustment to remove amounts in relation to employee share acquisitions arrangements from PBT - s425(2)",
      type: "positive",
      notes: tooltips.remove_employee_share_acquisitions_s425_2,
    },
    deductions_part11_part12_cta2009_s425_3: {
      label:
        "Adjustment to reflect deductions that would be allowed under Part 11 and Part 12 of CTA 2009 were all members of the group within the charge to corporation tax - s425(3)",
      type: "negative",
      notes: tooltips.deductions_part11_part12_cta2009_s425_3,
    },
    adjust_pbt_accounting_policy_changes_s426_2: {
      label:
        "Adjustment to PBT in respect of changes in accounting policy to align with the tax treatment that would arise for all items (including those impacting interest amounts) assuming the group was within the charge to corporation tax - s426(2)",
      type: null,
      notes: tooltips.adjust_pbt_accounting_policy_changes_s426_2,
    },
  };
}

export function getEbitdaAdjustmentsNonConsolidated(tooltips = {}) {
  return {
    //Adjustments in respect of the interest allowance (non-consolidated investment) election.
    exclude_income_financial_liabilities_s427_3a: {
      label:
        "Adjustment to PBT to exclude relevant income amounts relating to financial liabilities owed by any member of an associated worldwide group headed by a company specified in the election - s427(3)(a)",
      type: "negative",
      notes: tooltips.exclude_income_financial_liabilities_s427_3a,
    },
    exclude_interest_related_profit_loss_s427_3b: {
      label:
        "Adjustment to PBT to exclude any profit or loss attributable to an interest held by any member of the principal worldwide group in any member of an associated worldwide group headed by a company specified in the election - s427(3)(b)",
      type: null,
      notes: tooltips.exclude_interest_related_profit_loss_s427_3b,
    },
    adjust_group_ebitda_associated_groups_s427_6: {
      label:
        "Adjustment to increase / decrease Group-EBITDA by the appropriate proportion of the Group-EBITDA of each associated worldwide group headed by a company specified in the election - s427(6)",
      type: null,
      notes: tooltips.adjust_group_ebitda_associated_groups_s427_6,
    },
  };
}

export function getEbitdaAdjustmentsConsolidatedPartnership(tooltips = {}) {
  return {
    //Adjustments in respect of the interest allowance (consolidated partnership) election.
    exclude_consolidated_partnerships_amounts_s430_2a: {
      label:
        "Adjustment to PBT to exclude all amounts (including relevant interest income and expense amounts) recognised in respect of specified consolidated partnerships - s430(2)(a)",
      type: null,
      notes: tooltips.exclude_consolidated_partnerships_amounts_s430_2a,
    },
    include_equity_method_partnerships_s430_2b: {
      label:
        "Adjustment to PBT to include amounts that would arise if the specified consolidated partnerships were accounted for under the equity method - s430(2)(b)",
      type: null,
      notes: tooltips.include_equity_method_partnerships_s430_2b,
    },
  };
}

export function getEbitdaAdjustmentsQualifyingInfrastructureCompanies(
  tooltips = {},
) {
  return {
    //Adjustments in respect of qualifying infrastructure companies
    exclude_qualifying_infrastructure_companies_s442_3: {
      label:
        "Adjustment required such that Group-EBITDA is calculated as though the group did not include Qualifying Infrastructure companies. This should include interest amounts as adjustments to interest amounts are only made in calculating ANGIE/QNGIE - s442(3)",
      type: null,
      notes: tooltips.exclude_qualifying_infrastructure_companies_s442_3,
    },
  };
}

export function getEbitdaOther(tooltips = {}) {
  return {
    //Other
    specialist_regimes_other_adjustments: {
      label: "Other adjustments required as a result of specialist regimes",
      type: null,
      notes: tooltips.specialist_regimes_other_adjustments,
    },
    other_adjustments: {
      label: "Other adjustments",
      type: null,
      notes: tooltips.other_adjustments,
    },
  };
}

export function getEbitdaRowConfig(tooltips = {}) {
  return {
    ...getEbitdaProfitBeforeTax(tooltips),
    ...getEbitdaDepreciationAndAmortisationAdjustment(tooltips),
    ...getEbitdaCapitalFairValueMovementAdjustment(tooltips),
    ...getEbitdaCapitalDisposalsAdjustment(tooltips),
    ...getEbitdaAdjustentsInRespectOfTheInterestAllowanceAlternativeCalculation(
      tooltips,
    ),
    ...getEbitdaAdjustmentsNonConsolidated(tooltips),
    ...getEbitdaAdjustmentsConsolidatedPartnership(tooltips),
    ...getEbitdaAdjustmentsQualifyingInfrastructureCompanies(tooltips),
    ...getEbitdaOther(tooltips),
  };
}
